module.exports = __webpack_public_path__ + "media/Assignment_7.69e29abc.mp4";